import { render, staticRenderFns } from "./NftPortfolio.vue?vue&type=template&id=388e7178&"
import script from "./NftPortfolio.vue?vue&type=script&lang=js&"
export * from "./NftPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./NftPortfolio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports